'use strict';

require('./cn-help-text.scss');

module.exports = {
  template: require('./cn-help-text.html'),
  controller: require('./cn-help-text.controller'),
  controllerAs: 'vm',

  bindings: {
    textKey: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-help-text/index.js
 ** module id = 126
 ** module chunks = 0
 **/